import { ArrowNarrowUp } from '@untitledui/icons/ArrowNarrowUp'
import { useEffect, useState, type RefObject } from 'react'
import { twJoin } from 'tailwind-merge'

import { useIsWideLayout } from '@hooks/useMediaQuery'

interface Container {
  listContainerRef?: RefObject<HTMLElement | null>
  showAfter?: number
}

function ScrollToTopButton({ listContainerRef, showAfter = 300 }: Container) {
  const isWideLayout = useIsWideLayout()
  const [showButton, setShowButton] = useState(false)

  const btnStyles = twJoin(
    `
      absolute z-99 mr-2 ml-auto flex cursor-pointer items-center rounded-4xl bg-black p-[.875rem] text-sm text-white
      transition-all duration-300
    `,
    isWideLayout ? 'right-6 bottom-6' : 'right-2 bottom-2',
    showButton ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
  )

  useEffect(()=>{
    const listContainer = listContainerRef?.current
    if (!listContainer) return

    let isShowing = false

    function toggleButton(){
      if (!listContainer) return

      const shouldShow = listContainer.scrollTop > showAfter
      if (isShowing !== shouldShow) {
        isShowing = shouldShow
        setShowButton(shouldShow)
      }
    }

    listContainer.addEventListener('scroll', toggleButton)

    return ()=> listContainer.removeEventListener('scroll', toggleButton)
  }, [listContainerRef, showAfter])

  function scrollToTop() {
    const listContainer = listContainerRef?.current
    if (!listContainer) return

    listContainer.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return (
    <button onClick={scrollToTop} aria-label='Scroll to top' className={btnStyles}>
      <ArrowNarrowUp width={20} height={20} />
    </button>
  )
}

export default ScrollToTopButton